import { render, staticRenderFns } from "./law-header-bjh-dialog.vue?vue&type=template&id=614ddf9c&scoped=true"
import script from "./law-header-bjh-dialog.vue?vue&type=script&lang=js"
export * from "./law-header-bjh-dialog.vue?vue&type=script&lang=js"
import style0 from "./law-header-bjh-dialog.vue?vue&type=style&index=0&id=614ddf9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614ddf9c",
  null
  
)

export default component.exports